// Управление экранной клавиатурой на iOS (Capacitor) по индустриальному паттерну Ionic.
//
// Идея: webview НЕ ужимаем нативно (Keyboard.resize='none') — он остаётся во весь экран,
// поэтому клавиатура накладывается поверх веб-контента и сохраняет «родную» полупрозрачность
// (у resize='native' за клавиатурой пусто → серый фон + тёмные уголки).
//
// Вместо нативного ресайза контент поднимаем сами:
//   • keyboardWillShow → кладём высоту клавиатуры в CSS-переменную `--keyboard-height`.
//     MobileFrame читает её в padding-bottom (pb = safe-area + keyboard-height) → нижняя
//     часть фрейма уходит выше клавиатуры, поля становятся доступны.
//   • доскролливаем активное поле в зону видимости (resize='native' этого не делал — поле
//     оставалось под клавиатурой, пока не начнёшь печатать).
//   • keyboardWillHide → сбрасываем переменную в 0.
//
// Скролл корневого WKWebView отключён (ios.scrollEnabled=false) — это не даёт нативке
// «оттаскивать» фрейм под статус-бар; раскрытие поля делаем через scrollIntoView внутри
// `<main overflow-y-auto>`.

import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

let initialized = false;

export function initKeyboardInsets(): void {
  // Только нативные платформы: в браузере keyboardWillShow не существует.
  if (initialized || !Capacitor.isNativePlatform()) return;
  initialized = true;

  // Вернуть нативную панель над клавиатурой (стрелки ↑↓ между полями + «Готово»).
  // Плагин по умолчанию прячет её на iPhone; «Готово» также даёт закрыть цифровую
  // клавиатуру (OTP/часы/дата), где нет клавиши return. На iPad панель всегда видна.
  void Keyboard.setAccessoryBarVisible({ isVisible: true });

  const root = document.documentElement;

  void Keyboard.addListener('keyboardWillShow', (info) => {
    root.style.setProperty('--keyboard-height', `${info.keyboardHeight}px`);

    // rAF: ждём пересчёта layout от нового padding, иначе scrollIntoView мажет по старой
    // геометрии. block:'center' — держим поле комфортно над клавиатурой.
    const el = document.activeElement as HTMLElement | null;
    if (el && typeof el.scrollIntoView === 'function') {
      requestAnimationFrame(() => el.scrollIntoView({ block: 'center' }));
    }
  });

  void Keyboard.addListener('keyboardWillHide', () => {
    root.style.setProperty('--keyboard-height', '0px');
  });
}
